import React from 'react';

import { Stack } from '@mui/material';

import { StlButton } from './StlButton/StlButton';

const baseButtonSx = {
  borderRadius: '2px',
  height: '24px',
  minWidth: 'unset',
};

const stackSx = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1,
  mt: 0.5,
  justifyContent: 'flex-end',
};

interface IStlConfirmButtons {
  handleApply: () => void;
  handleCancel: () => void;
  width?: number | string;
  confirmTxt?: string;
  disabled?: boolean;
}

export default function StlConfirmButtons({
  handleApply,
  handleCancel,
  width = '50%',
  confirmTxt = 'Apply',
  disabled = false,
}: IStlConfirmButtons) {
  const buttonSx = {
    ...baseButtonSx,
    maxWidth: width,
  };
  return (
    <Stack sx={stackSx}>
      <StlButton
        sx={buttonSx}
        value="Cancel"
        handleClick={handleCancel}
        width={width}
        brown
      />
      <StlButton
        value={confirmTxt}
        isActive={!disabled}
        handleClick={handleApply}
        width={width}
        sx={buttonSx}
      />
    </Stack>
  );
}
